import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const pg_token = params.get("pg_token");
    const tid = localStorage.getItem("tid");
    const email = localStorage.getItem("email");

    const approve = async () => {
      const res = await fetch(
        `http://localhost:8000/payment/kakaopay/approve?pg_token=${pg_token}&tid=${tid}&email=${email}`
      );
      const data = await res.json();
      alert(data.message);
      navigate("/"); // 메인으로
    };

    if (pg_token && tid && email) {
      approve();
    }
  }, []);

  return <div>결제 승인 중입니다...</div>;
}

export default PaymentSuccess;
